module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-uploader__dropzone-list"
  }, _vm._l((_vm.qualityArray), function(quality) {
    return _c('div', {
      key: quality,
      staticClass: "file-uploader__dropzone-list-item"
    }, [_c('p', {
      staticClass: "file-uploader__quality-label"
    }, [_vm._v(_vm._s((quality + "p:")))]), _vm._v(" "), _c('div', {
      staticClass: "files-uploader__select-row",
      on: {
        "click": function($event) {
          return _vm.onSelectelUploaderClick(quality)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filesDictionary[quality].type),
        expression: "filesDictionary[quality].type"
      }],
      attrs: {
        "type": "radio",
        "name": ("uploadVideoGroup" + quality)
      },
      domProps: {
        "value": _vm.URL,
        "checked": _vm._q(_vm.filesDictionary[quality].type, _vm.URL)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.filesDictionary[quality], "type", _vm.URL)
        }
      }
    }), _vm._v(" "), _c('SelectelUploader', {
      attrs: {
        "file-link": _vm.filesDictionary[quality].url,
        "selectel-list": _vm.selectelList,
        "selectel-loading": _vm.selectelLoading,
        "link-status": _vm.filesDictionary[quality].linkStatus
      },
      on: {
        "blur": function($event) {
          return _vm.checkLink(quality)
        },
        "file-attached": function($event) {
          return _vm.attachFile($event, quality)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "files-uploader__select-row",
      on: {
        "click": function($event) {
          return _vm.onFileUploaderClick(quality)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filesDictionary[quality].type),
        expression: "filesDictionary[quality].type"
      }],
      attrs: {
        "type": "radio",
        "name": ("uploadVideoGroup" + quality)
      },
      domProps: {
        "value": _vm.FILE,
        "checked": _vm._q(_vm.filesDictionary[quality].type, _vm.FILE)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.filesDictionary[quality], "type", _vm.FILE)
        }
      }
    }), _vm._v(" "), _c('Dropzone', {
      ref: ("dropzone" + quality),
      refInFor: true,
      staticClass: "dropzone-noprogress",
      attrs: {
        "id": ("files-uploader-" + quality),
        "options": _vm.dropzoneOptions
      },
      on: {
        "vdropzone-removed-file": function($event) {
          return _vm.videoRemoved($event, quality)
        },
        "vdropzone-file-added": function($event) {
          return _vm.videoAdded($event, quality)
        }
      }
    })], 1)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0225fa73","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/FileUploader/VideoQualityUploader.vue
// module id = 806
// module chunks = 0